import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {fromEvent} from 'rxjs';

import {ApiService} from '../shared/api.service';
import {UserService} from '../shared/user.service';
import { GettyService } from '../getty/getty.service';


@Component({
    selector: 'getty-window',
    templateUrl: 'getty-window.component.html'
})
export class GettyWindowComponent {
    progress = false;
    showLogin = true;
    assignmentId = 0;
    storageSubscription;

    constructor(
        private api: ApiService, 
        private userService: UserService, 
        private titleService: Title,
        private gettyService: GettyService
    ) {
        this.gettyService.subscribedEvents = [
            'FULLFILLFIRSTLOAD',
            'FILTERSCHANGED',
            'ASSIGNMENTLOADED',
            'WINDOWFOCUSED',
            'DOWNLOADING',
            'DOWNLOADCOMPLETE',
            'DOWNLOADERROR',
            'RESETERRORS'
        ];
        this.storageSubscription = fromEvent(window, 'storage').subscribe(e => {
            this.gettyService.handleStorageEvents(e);
        });
        if( this.api.getProp('currentUserId') ) {
            this.showLogin = false;
        }
        this.api.progress.subscribe(
            progress => {
                this.progress = progress;
            }
        );
        this.userService.user.subscribe(user => {
            if( user.id ) {
                this.showLogin = false;
            } else {
                this.showLogin = true;
            }
        });
    }
    ngAfterViewInit() {
        this.titleService.setTitle('SWARM | GettyImages Search');
    }
}